export default __webpack_public_path__ + "static/uk-dd09601ff8e7c843cca2804370543191.png";